import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MyErrorStateMatcher } from '../../mago-university/training-request/training-request.component';
import { ListTypes, ProductBugsReleasesFinderReq } from 'src/app/model/ProductBugsReleaseFinderReq';
import { ProductDownloadService } from 'src/app/core/services/product-download.service';
import { ProductRelease } from 'src/app/model/ProductRelease';
import { WorkFlowService } from 'src/app/core/services/work-flow.service';
import { MatSelectChange } from '@angular/material/select';

@Component({
  selector: 'ms-product-bugs-releases-founder',
  templateUrl: './product-bugs-releases-founder.component.html',
  styleUrls: ['./product-bugs-releases-founder.component.scss']
})
export class ProductBugsReleasesFounderComponent implements OnInit {
  searchFormControl = new FormControl('', [Validators.required, Validators.email]);
  matcher = new MyErrorStateMatcher();

  request: ProductBugsReleasesFinderReq = new ProductBugsReleasesFinderReq()
  releases: string[] = [];
  functionalAreas: string[] = [];

  isLoading: boolean = false;

  constructor(
    private productDownloadService: ProductDownloadService,
    private workflow: WorkFlowService
  ) {
  }

  ngOnInit(): void {
  }

  setReleases(): void {
    this.isLoading = true;
    this.productDownloadService.getProductReleases(this.request.ProductFamily, this.request.ProductFamily, 'all', null, null, true)
    .then((res) => {
      if(res.Result && res.Content != null)
        this.releases =  res.Content.map(pr => pr.ReleaseNr);
      this.isLoading = false
    })
    .catch(() => {
      this.isLoading = false
      this.workflow.showSnackBar('Release error', 'Error during loading releases');
    })
  }

  setFunctionalAreas(event: MatSelectChange): void {
    if(event.value == ListTypes.Bug.valueOf())
      this.setBugFunctionalAreas()
    else if(event.value == ListTypes.Release.valueOf())
      this.setReleaseFunctionalAreas()
  }

  setBugFunctionalAreas(): void{
    this.isLoading = true;
    this.productDownloadService.getProductBugs(this.request.ProductFamily, this.request.ProductRelease).then((res) => {
      if(res.Result){
        res.Content.forEach(bug => {
          if(!this.functionalAreas.includes(bug.FunctionalAreas))
            this.functionalAreas.push(bug.FunctionalAreas)
        })
      }
      this.isLoading = false;
    })
    .catch((err) => {
      this.isLoading = false
      this.workflow.showSnackBar('Functional Area error', 'Error during loading functional areas');
    })
  }

  setReleaseFunctionalAreas(): void{
    this.isLoading = true;
    this.productDownloadService.getProductImprovements(this.request.ProductFamily, this.request.ProductRelease).then((res) => {
      if(res.Result){
        res.Content.forEach(release => {
          if(!this.functionalAreas.includes(release.FunctionalAreas))
            this.functionalAreas.push(release.FunctionalAreas)
        })
      }
      this.isLoading = false;
    })
    .catch((err) => {
      this.isLoading = false
      this.workflow.showSnackBar('Functional Area error', 'Error during loading functional areas');
    })
  }

  isFunctionalAreaInputDisabled(): boolean{
    const stringKeys = Object.keys(ListTypes).filter((v) => isNaN(Number(v)))


      stringKeys.forEach((listType) => {
        if(listType == this.request.ListType?.valueOf()?.toString())
          return false
      })
      return true

  }

}
